module.exports = __webpack_public_path__ + "img/reportclosure.cc9a7e91.svg";